module.exports = __webpack_public_path__ + "r-v3/img/user_device_pc_in.3cbd09eb.svg";